import { Locale } from '@doordash/lib-i18n'

/**
 * This function take in a string and check if its in locale form eg. `EN_US`
 *
 * @param maybeLocale
 * @returns
 */
const getIsLocale = (maybeLocale: string): maybeLocale is Locale =>
  Boolean(Locale[maybeLocale.toUpperCase().replace('-', '_')])

export default getIsLocale
